import { render, staticRenderFns } from "./themactlist-index.vue?vue&type=template&id=47a325cc&scoped=true&"
import script from "./themactlist-index.vue?vue&type=script&lang=js&"
export * from "./themactlist-index.vue?vue&type=script&lang=js&"
import style0 from "./themactlist-index.vue?vue&type=style&index=0&id=47a325cc&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a325cc",
  null
  
)

export default component.exports